import React, {Component} from 'react';
import ProjectTotalHeaderItem from './project_total_header_item';

import {injectIntl} from 'react-intl';

class ProjectTotalHeader extends Component {
	constructor(props) {
		super(props);

		this.state = {
			projectTotalExpanded: true,
		};
	}

	componentDidUpdate(prevState, prevProps) {
		const shouldAnimate = prevProps.projectTotalExpanded !== this.props.projectTotalExpanded;
		if (shouldAnimate !== this.state.shouldAnimate) {
			this.setState({
				shouldAnimate: shouldAnimate,
			});
		}
	}

	toggleProjectTotal(e) {
		e.stopPropagation();
		e.preventDefault();
		this.props.toggleProjectTotalExpanded();
	}

	getElemForCol(col) {
		const {formatMessage} = this.props.intl;
		const colName = col.name;
		let item = null;

		switch (colName) {
			case 'task-name':
				item = {label: formatMessage({id: 'scope.project-total'}), value: ' ', cy: 'total-name'};
				break;
			case 'low-estimate':
				item = {label: formatMessage({id: col.translationId}), value: this.props.low, cy: 'total-low'};
				break;
			case 'high-estimate':
				item = {label: formatMessage({id: col.translationId}), value: this.props.high, cy: 'total-high'};
				break;
			case 'forecast':
				item = {label: formatMessage({id: col.translationId}), value: this.props.forecast, cy: 'total-forecast'};
				break;
			case 'done-percentage':
				item = {label: formatMessage({id: col.translationId}), title: col.title ? formatMessage({id: col.title}) : '', value: this.props.lazyDataFetched ? this.props.done : '-', cy: 'total-done'};
				break;
			case 'time-entries':
				item = {label: formatMessage({id: col.translationId}), value: this.props.lazyDataFetched ? this.props.timeEntries : '-', cy: 'total-time'};
				break;
			case 'remaining':
				item = {label: formatMessage({id: col.translationId}), value: this.props.lazyDataFetched ? this.props.remaining : '-', cy: 'total-remaining'};
				break;
			case 'over-high':
				item = {label: formatMessage({id: col.translationId}), value: this.props.lazyDataFetched ? this.props.overHigh : '-', cy: 'total-over-high'};
				break;
			case 'over-forecast':
				item = {label: formatMessage({id: col.translationId}), value: this.props.lazyDataFetched ? this.props.overForecast : '-', cy: 'total-over-forecast'};
				break;
			case 'price':
				item = {label: formatMessage({id: col.translationId}), value: this.props.price, cy: 'total-price', title: this.props.price};
				break;
			case 'actual-price':
				item = {label: formatMessage({id: col.translationId}), value: this.props.lazyDataFetched ? this.props.actualPrice : '-', cy: 'total-actual', title: this.props.actualPrice};
				break;
			case 'date':
			case 'assigned-role':
			case 'assigned-person':
			case 'status':
			case 'sprint':
			case 'milestone':
			case 'approved':
			case 'selector':
			case 'chip-right':
				item = {value: '', label: ''};
				break;
			default:
				item = null;
				break;
		}
		if (item && item.value !== null && item.value !== '') {
			return (
				<ProjectTotalHeaderItem
					multiLine={col.multiLine}
					shouldAnimate={this.state.shouldAnimate}
					textAlign={col.align}
					key={item.label}
					projectTotalExpanded={this.props.projectTotalExpanded}
					label={item.label}
					value={item.value}
					cy={item.cy}
					title={item.title}
				/>
			);
		}
	}

	getProjectRegElemForCol(col) {
		const {formatMessage} = this.props.intl;
		const colName = col.name;
		let item = null;

		switch (colName) {
			case 'task-name':
				item = {
					label: null,
					value: formatMessage({id: 'scope.time_on_project'}).toUpperCase(),
					cy: 'total-name',
					itemType: ' on-project-name',
					title: formatMessage({id: 'scope.time_on_project'}),
				};
				break;
			case 'time-entries':
				item = this.props.lazyDataFetched ? this.props.projectTimeRegistered : {value: '-'};
				break;
			case 'actual-price':
				item = {label: null, value: this.props.lazyDataFetched ? this.props.projectReportedTimePrice : '-', cy: 'total-actual', title: this.props.lazyDataFetched ? this.props.projectReportedTimePrice : '-'};
				break;
			case 'low-estimate':
			case 'high-estimate':
			case 'forecast':
			case 'done-percentage':
			case 'remaining':
			case 'over-high':
			case 'over-forecast':
			case 'price':
			case 'date':
			case 'assigned-role':
			case 'assigned-person':
			case 'status':
			case 'sprint':
			case 'milestone':
			case 'approved':
			case 'chip-right':
				item = {value: '', label: null};
				break;
			default:
				item = null;
				break;
		}
		if (item && item.value !== null && item.value !== '') {
			return (
				<ProjectTotalHeaderItem
					multiLine={col.multiLine}
					shouldAnimate={this.state.shouldAnimate}
					textAlign={col.align}
					key={item.label}
					projectTotalExpanded={this.props.projectTotalExpanded}
					label={item.label}
					value={item.value}
					cy={item.cy}
					itemType={item.itemType ? item.itemType : ''}
					title={item.title}
				/>
			);
		}
	}

	render() {
		const headerItems = [];
		const projectRegistrationItems = [];
		this.props.availableColumns.forEach(col => {
			if ((col.checked && !col.notAnElem) || col.maintainSpace) {
				if (col.maxWidth) {
					headerItems.push({element: this.getElemForCol(col), minWidth: col.minWidth, maxWidth: col.maxWidth, marginRight: col.marginRight});
					projectRegistrationItems.push({element: this.getProjectRegElemForCol(col), minWidth: col.minWidth, maxWidth: col.maxWidth, marginRight: col.marginRight});
				} else {
					headerItems.push({element: this.getElemForCol(col), minWidth: col.minWidth, marginRight: col.marginRight});
					projectRegistrationItems.push({element: this.getProjectRegElemForCol(col), minWidth: col.minWidth, marginRight: col.marginRight});
				}
			}
		});
		const minWidth = this.props.tableMinWidth - 4 + 26 - (this.props.sideBacklog ? 12 : 0) + (this.props.hasApproved ? 90 : 0);
		const taskCellMaxWidth = this.props.sideBacklog ? this.props.taskCellMaxWidth - 12 : this.props.taskCellMaxWidth;

		const shouldShowProjectRegistrations = this.props.availableColumns.find(col => col.checked && (col.name === 'time-entries' || col.name === 'actual-price'));

		return (
			<div
				className={
					'project-total-container' +
					(this.props.projectTotalExpanded ? ' expanded' : ' collapsed') +
					(!this.props.hasScroll ? ' hide-shadow' : '') +
					(this.props.sideBacklog ? ' side-space' : '') +
					(shouldShowProjectRegistrations ? ' large' : '') +
					(this.props.baselineHeaderElement ? ' baseline' : '')
				}
				onClick={this.toggleProjectTotal.bind(this)}
				style={{minWidth: minWidth}}
				data-userpilot={'project-totals-header'}
			>
				<div className={'items'}>
					{headerItems.map((obj, index) => (
						<div
							key={index}
							className={'elem-wrapper' + (!obj.maxWidth ? ' growable' : '')}
							style={{
								maxWidth: index === 0 ? taskCellMaxWidth : obj.maxWidth,
								minWidth: index === 0 ? taskCellMaxWidth : obj.maxWidth,
							}}
							title={obj.title}
						>
							{obj.element}
						</div>
					))}
				</div>
				<div className="toggle" data-userpilot={'expand-project-totals-button'}>
					<div onClick={this.toggleProjectTotal.bind(this)} className={'icon-chevron' + (this.props.projectTotalExpanded ? ' expanded' : ' not-expanded') + (this.props.baselineHeaderElement ? ' baseline' : '')} />
				</div>
				{this.props.projectTotalExpanded && shouldShowProjectRegistrations ? (
					<div className={'project-time-registrations items'}>
						{projectRegistrationItems.map((obj, index) => (
							<div
								key={index}
								className={'elem-wrapper' + (!obj.maxWidth ? ' growable' : '')}
								style={{
									maxWidth: index === 0 ? taskCellMaxWidth : obj.maxWidth,
									minWidth: index === 0 ? taskCellMaxWidth : obj.maxWidth,
								}}
							>
								{obj.element}
							</div>
						))}
					</div>
				) : null}
				{this.props.baselineHeaderElement}
			</div>
		);
	}
}

ProjectTotalHeader.propTypes = {};

export default injectIntl(ProjectTotalHeader);
